import React from "react";
import { Counterparty } from "@common/types/counterparty";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import { TransactionRule } from "@common/types/transactionRule";
import styles from "../RulesTable.module.scss";
import { TransactionRuleConditions } from "../../../transactionRules/TransactionRuleConditions";
import { TransactionRuleActions } from "../../../transactionRules/TransactionRuleActions";

interface RuleOverlayProps {
    rule: TransactionRule;
    counterparties: Counterparty[];
    normalizedDescriptions: NormalizedDescriptionInfo[];
}

export const RuleOverlay: React.FC<RuleOverlayProps> = ({
    rule,
    counterparties,
    normalizedDescriptions,
}) => (
    <table>
        <thead style={{ display: "none" }}>
            <tr>
                <th aria-hidden="true"></th>
            </tr>
        </thead>
        <tbody>
            <tr className={styles.ruleOverlayRow}>
                <td>
                    <TransactionRuleConditions
                        rule={rule}
                        counterparties={counterparties}
                        normalizedDescriptions={normalizedDescriptions}
                        hideEntityCondition
                    />
                </td>
                <td>
                    <TransactionRuleActions
                        rule={rule}
                        counterparties={counterparties}
                    />
                </td>
            </tr>
        </tbody>
    </table>
);
